<!-- Botón de Cierre del Diálogo -->
<app-button-close-dialog></app-button-close-dialog>

<!-- Título del Diálogo -->
<h1 mat-dialog-title>Ver Registro Contable</h1>
<br>

<mat-dialog-content>

  <!-- Spinner de Carga -->
  <ngx-spinner [zIndex]="100" name="spLoadView" bdColor="rgba(255,255,255,0.8)" size="default"
    color="var(--primary-color)" type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <!-- Acordeón Principal -->
  <mat-accordion>

    <!-- Sección: Información General -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title> General </mat-panel-title>
        <mat-panel-description>
          Información del Registro Contable
        </mat-panel-description>
      </mat-expansion-panel-header>

      <ngx-spinner name="spBusquedaRoles" bdColor="rgba(255,255,255,0.8)" size="default" color=" var(--primary-color)"
        type="ball-atom" [fullScreen]="false">
      </ngx-spinner>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field appearance="outline">
              <input placeholder="Descripción" type="text" formControlName="Descripcion" matInput />
              <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>


    </mat-expansion-panel>
  </mat-accordion>

</mat-dialog-content>

<!-- Botón de Cerrar -->
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" style="margin-right: 3px" name="Cancelar" [mat-dialog-close]="true">
    <span>Cancelar</span>
  </button>
</mat-dialog-actions>
